export const KEYS = Object.freeze({
  ESCAPE: 'Escape',
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  ENTER: 'Enter',
  SPACE: ' ',
});

/**
 *
 * @param {KEYS} key
 */
const keyPressed = key => event => event.key === key;

export const keyPressIsEscape = keyPressed(KEYS.ESCAPE);
export const keyPressIsArrowDown = keyPressed(KEYS.ARROW_DOWN);
export const keyPressIsArrowUp = keyPressed(KEYS.ARROW_UP);
export const keyPressIsEnter = keyPressed(KEYS.ENTER);
export const keyPressIsSpace = keyPressed(KEYS.SPACE);

/**
 * Checks if the key pressed is any of the ones provided.
 * @param {Array<KEYS>} keys
 */
export const keyMatcher = keys => event => keys.includes(event.key);

/**
 * Checks if either Arrow Down, Enter or Space was pressed.
 */
export const a11yOpenkeyMatcher = keyMatcher([
  KEYS.ARROW_DOWN,
  KEYS.ENTER,
  KEYS.SPACE,
]);
